import { useState } from "react";
import NotificationPanel from "../../action-center/notification-panel/NotificationPanel";
import AppPanel from "../../app-panel/AppPanel";
import LockScreen from "../../lock-screen/LockScreen";
import Display from "../display/Display";
import Styles from "./Wallpapers.module.scss";
import classnames from "classnames"
import { getCurrentOption } from "../../../../global/functions/functrions";
import WallpapersContainer from "./wallpapers-container/WallpapersContainer";
import HomeAndLockScreen from "../home-and-lock-screen/HomeAndLockScreen";

interface WallpaperProps {
    wallpapers: any
    subOptions: any
    activeOption: string
    onClickOption: (data: any) => void;
}

const Wallpapers = ({ wallpapers, subOptions, activeOption, onClickOption }: WallpaperProps) => {
    
    const getScreen = () => {
        switch (getCurrentOption(activeOption)) {
            case "6_1": return <WallpapersContainer wallpapers={wallpapers} />
            default: return (
                <>
                    <HomeAndLockScreen/>
                    {
                        subOptions &&
                        <div className={"solid_bg"}>
                            {
                                subOptions.map((option: any, index: number) => {
                                    return (
                                        <div className={classnames(Styles.option, index != subOptions.length - 1 && Styles.divider)} key={option.id} onClick={() => { onClickOption(option.id) }} >
                                            {option.leftComponent && option.leftComponent}
                                            {option.rightComponent && option.rightComponent}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </>
            )
        }
    }

    return (
        <div className={Styles.container}>
            {getScreen()}
        </div>
    )
}

export default Wallpapers
